import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { AccountDeviceModel } from '../models/AccountDevicesModel';

@Injectable()
export class WaterUsageService {

  constructor(private http: HttpClient) { }

  getNextEstimatedBill(orgUnitId: string, deviceId: string): Observable<any> {

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('deviceId', deviceId);

    return this.http.get<any>('/Portal/GetNextEstimatedBill', { params });
  }

  getCurrentBill(orgUnitId: string, deviceId: string): Observable<any> {

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('deviceId', deviceId)
      .set('currentBill', 'true');

    return this.http.get<any>('/Portal/GetNextEstimatedBill', { params });
  }

  getBillingPeriod(orgUnitId: string, deviceId: string): Observable<any> {

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('deviceId', deviceId);

    return this.http.get<any>('/Portal/GetBillingPeriod', { params });
  }

  getComputedValue(deviceId: string): Observable<any> {

    const params = new HttpParams()
      .set('deviceId', deviceId);

    return this.http.get<any>('/Portal/GetComputedValue', { params });
  }

  getWaterUsageData(deviceModel: AccountDeviceModel): Observable<any> {
    let _body = JSON.stringify(deviceModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/GetWaterUsage', _body, httpOptions);
  }

  getRecentWaterUsageData(deviceModel: AccountDeviceModel): Observable<any> {
    let _body = JSON.stringify(deviceModel);

    //const params = new HttpParams()
    //  .set('timeRange', timeRange);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      //params: params
    }

    return this.http.post<any>('/Portal/GetAllRecentWaterUsage', _body, httpOptions);
  }

  getWaterUsageComparisonData(deviceModel: AccountDeviceModel): Observable<any> {
    let _body = JSON.stringify(deviceModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/GetAllRecentWaterUsageComparison', _body, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/water-usage.service.ts